<template>
  <div class="flex-1 mt-1 bg-gray-100 px-4 pt-12 mb-20  items-center">
    <div class="bg-white w-fullrounded-lg shadow">
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-2">
        <div class="flex">
          <button
            :class="$colors.primary"
            class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
            @click="RouterBack()"
          >
            <i class="material-icons">chevron_left</i>
          </button>
          <div v-if="!formData._id" class="text-2xl font-bold text-blue-500">New Sourcing
          </div>
          <div v-else class="text-2xl font-bold text-blue-500">Edit Sourcing
          </div>
        </div>
      </div>

      <div class="">
        <div class="bg-white rounded-lg p-6 pt-2">
          <div>
            <!-- ************************************************************************************ -->
            <!-- ************************************Select Colis***********************************-->
            <div class="px-6 mt-3">
              <div class="flex w-full space-x-2">
                <div class="flex w-1/2 justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                  <div class="flex w-full">
                    <span class="rounded-full h-12 w-12 bg-gray-200">
                      <i class="material-icons p-3 text-blue-400">person</i>
                    </span>

                    <div class="ml-5 w-full">
                      <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                        Country information
                      </div>
                      <div class="text-sm font-light text-gray-500"></div>
                      <div class="w-full space-y-4">
                      
                        <div
                          class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p>
                              <label for="customerPhone" class="bg-white text-gray-700 px-1">Country of purchase 
                                <span :class="$colors.required">*</span></label>
                            </p>
                          </div>
                          <p>
                            <v-select @input="setSelected" v-model="formData.country" :options="options" label="name">
                                <template slot="option" slot-scope="option">
                                    <img class="flag-img" :src="$f.getCountryCode(option.code)"/>
                                    {{ option.name }} 
                                </template>
                            </v-select>
                          </p>
                        </div>
                        <div
                          class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p>
                              <label for="customerPhone" class="bg-white text-gray-700 px-1">Country warehousing
                                <span :class="$colors.required">*</span></label>
                            </p>
                          </div>
                          <p>
                            <v-select @input="setSelectedW" v-model="formData.warehouse" :options="warehouses" label="name">
                                <template slot="option" slot-scope="option">
                                    <img class="flag-img" :src="$f.getCountryCode(option.country)"/>
                                    {{ $f.getCountryNameByCode(options,option.country)}} 
                                </template>
                            </v-select>
                          </p>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <!-- ****************************** Order Information *********************************************-->

                <div class="flex w-1/2 justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                  <div class="flex w-full mt-2">
                    <span class="rounded-full h-12 w-12 bg-gray-200">
                      <i class="material-icons p-3 text-blue-400">local_grocery_store</i>
                    </span>

                    <div class="ml-5 w-full">
                      <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                        Provider information
                      </div>
                      <div class="text-sm font-light text-gray-500"></div>
                      <div class="w-full space-y-4">
                        <div class="flex">
                          <div
                            class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                              <p>
                                <label for="source" class="bg-white text-gray-700 px-1">Name
                                  <span :class="$colors.required">*</span></label>
                              </p>
                            </div>
                            <p>
                              <input id="source" autocomplete="false" tabindex="0" type="text"
                                v-model="formData.provider.name"
                                class="py-2 text-xs px-2 outline-none block h-full w-full" />
                            </p>
                          </div>
                        </div>

                        <div
                          class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p>
                              <label for="sourceLink" class="bg-white text-gray-700 px-1">Phone
                                <span :class="$colors.required">*</span></label>
                            </p>
                          </div>
                          <p>
                            <input id="sourceLink" autocomplete="false" tabindex="0" type="text"
                              v-model="formData.provider.phone"
                              class="py-2 text-xs px-2 outline-none block h-full w-full" />
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Status and seller Administartion -->
              <div class="bg-white rounded-lg p-6">
                  <div class="grid lg:grid-cols-2 gap-6">
                      <div v-if="currentUser.type != 'Seller'" class="border seller-select h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                          <p>
                            <label for="seller" class="bg-white text-gray-700 px-1"> Seller
                            <span :class="$colors.required">*</span></label>
                          </p>
                        </div>    
                        <p>
                            <v-select label="fullName" @search="getUsersDebance($event,'shipsen')" v-model="formData.seller" :options="sellers"></v-select>
                        </p>
                        
                      </div>  
                      <div v-if="formData._id && currentUser.type != 'Seller'" class="border seller-select h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                          <p>
                            <label for="seller" class="bg-white text-gray-700 px-1">Status
                            <span :class="$colors.required">*</span></label>
                          </p>
                        </div>
                        <p>
                           <select name="status" autocomplete="type" v-model="formData.status"
                                class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white">
                                <option class="bg-white" selected :value="null">Status</option>
                                <option class="bg-white text-gray-600" v-for="(value, index) in status" :key="index" :value="value">
                                    {{ value }}
                                </option>
                            </select>
                        </p>
                      </div> 
                      <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                              <p>
                                  <label for="dateexpar" class="bg-white text-gray-700 px-1">Facturation date
                                      <span :class="$colors.required">*</span></label>
                              </p>
                          </div>
                          <p>
                                <datetime-v2 type="datetime" v-model="formData.facturationDate"
                                        placeholder="FacturationDate date ..." input-class="py-1 text-xs px-2 outline-none block h-full w-full" ></datetime-v2> 
                          </p>
                      </div>
                  </div>  
              </div>     

              <!-- ********************************************************Product Table assigned to expedition **********************************-->
              <div class="flex w-full">
                <div class="flex space-x-2 w-full shadow-xs mt-1 rounded-lg">
                  <div class="flex w-full justify-between items-center h-auto p-6">
                    <div class="flex w-full">
                      <span class="rounded-full h-12 w-12 bg-gray-200">
                        <i class="material-icons p-3 text-blue-500">local_mall</i>
                      </span>
                      <div class="ml-3 w-full p-2 pb-8">
                        <div class="w-full flex text-base font-semibold text-gray-600">
                          <p class="w-1/2">Products && Fees</p>
                          <div class="w-full">
                            <button @click="OpenPopUp" :disabled="!formData.seller"
                              class="flex text-white mx-auto max-w-sm rounded-md text-center bg-blue-500 py-2 px-8 items-center focus:outline-none md:float-right">
                              Select Product
                            </button>
                          </div>
                        </div>

                        <div v-if="formData.details" class="mt-4 overflow-x-auto">
                           <h4 class="other-fees">Products</h4>
                          <table class="min-w-full table item leading-normal">
                            <thead>
                              <tr>
                                <th
                                  class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider">
                                  ID
                                </th>
                                <th
                                  class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider">
                                  Name
                                </th>

                                <th
                                  class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider">
                                  Quantity
                                </th>

                                 <th
                                  class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider">
                                  Unit Price <sup>(MAD)</sup>
                                </th>

                                 <th
                                  class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider">
                                  Unit Price <sup v-if="formData.warehouse">({{formData.warehouse.currency}})</sup>
                                </th>

                                <th
                                  class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider">
                                  Actions
                                </th>
                              </tr>
                            </thead>
                            <tbody v-for="(item, index) in formData.details" :key="index">
                              <tr>
                                <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                                  <div class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900">
                                    <b>{{ item.product.id }}</b>
                                  </div>
                                </td>
                                <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                                  <div class="text-xs w-160px whitespace-pre-wrap leading-5 capitalize px-2 rounded-full text-gray-900">
                                    {{ item.product.name }}
                                  </div>
                                </td>
                                <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                                  <div class="flex space-x-6">
                                    <button :class="$colors.textPrimary"
                                      class="bg-blue-500 rounded-md w-6 h-6 flex items-center focus:outline-none"
                                      @click="addQuantity(index)">
                                      <span class="font-bold text-2xl text-white">
                                        <i class="material-icons mt-2">add</i>
                                      </span>
                                    </button>

                                     <span :class="$colors.textPrimary" class="text-gray-700 text-sm h-6 flex items-center focus:outline-none">
                                         <input class="focus:outline-none w-12 text-center" type="text" v-model="item.quantity">
                                     </span>

                                    <button :class="$colors.textPrimary" @click="removeQuantity(index)"
                                      class="bg-blue-500 rounded-md w-6 h-6 text-white flex items-center focus:outline-none">
                                      <span class="font-bold text-2xl text-white mt-1">
                                        <i class="material-icons">remove</i>
                                      </span>
                                    </button>
                                  </div>
                                  <div class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"></div>
                                </td>
                                 <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                                    <div class="w-full rounded-md inline-flex border">
                                        <div class="flex items-center font-bold text-s  w-100px justify-center border border-gray-200 w-1/4 bg-gray-100">
                                             MAD
                                        </div>
                                        <input type="number" v-model="item.priceDH" min="0" class="w-full focus:outline-none rounded-md bg-white text-gray-700 focus:text-gray-600 p-2">
                                    </div>
                                </td>
                                 <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                                    <div class="w-full rounded-md inline-flex border">
                                        <div class="flex items-center  font-bold text-s  w-100px justify-center border border-gray-200 w-1/4 bg-gray-100">
                                            <span v-if="formData.warehouse"> {{formData.warehouse.currency}}</span>
                                        </div>
                                        <input type="number" v-model="item.price" disabled min="0" class="w-full focus:outline-none rounded-md bg-white  text-gray-700 focus:text-gray-600 p-2">
                                    </div>
                                </td>

                                <td class="py-4 whitespace-no-wrap border-b border-gray-200">
                                  <div class="flex justify-center">
                                    <button @click="removeProduct(item, index,'products')" :class="$colors.actionTable"
                                      class="rounded-full flex focus:outline-none w-8 h-8 mr-3 mt-1">
                                      <i class="material-icons mx-1">delete</i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <h4 class="other-fees">Other fees</h4>
                           <div v-if="formData.details.length>0" class="app-theme  invoice-item-list content-block">
                            <table class="table invoice-table  invoice-table-edit">
                                 <thead class="thead">
                                     <tr><th class="invoice-detail-margin">&nbsp;</th><th class="invoice-detail-summary bg-gray-50">Fees name</th><th class="invoice-detail-quantity bg-gray-50">Price <sup>(MAD)</sup></th><th class="invoice-detail-total bg-gray-50">Price <sup v-if="formData.warehouse">({{formData.warehouse.currency}})</sup></th></tr>
                                 </thead>
                                 <tbody class="invoice-items">
                                    <tr class="item-row item-row-1 with-tax" v-for="(item, index) in formData.fees" :key="index">
                                        <td class="item-row-actions"><div class="confirm-delete-button"><button @click="removeProduct(item, index,'fees')" title="Remove Item" class="btn btn-remove"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times" class="svg-inline--fa fa-times fa-w-11 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512"><path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg></button></div></td>
                                        <td data-label="Item #1" class="item-row-summary"><span class="item-row-name"><div class="item-suggest"><div role="combobox" aria-haspopup="listbox" aria-owns="react-autowhatever-1" aria-expanded="false" class="react-autosuggest__container"><input type="text" v-model="item.name" autocomplete="off" aria-autocomplete="list" aria-controls="react-autowhatever-1" class="react-autosuggest__input" id="invoice-item-code" placeholder="Fees name" value=""><div id="react-autowhatever-1" role="listbox" class="react-autosuggest__suggestions-container"></div></div></div></span></td>
                                        <td data-label="Quantity" class="item-row-quantity">
                                             <div class="w-full rounded-md inline-flex border">
                                                <div class="flex items-center font-bold text-s  w-100px justify-center border border-gray-200 w-1/4 bg-gray-100">MAD</div>
                                                <input type="number" v-model="item.priceDH" min="0" class="w-full focus:outline-none rounded-md bg-white text-gray-700 focus:text-gray-600 p-2">
                                            </div>
                                        </td>
                                        <td data-label="Amount" class="item-row-amount">
                                               <div class="w-full rounded-md inline-flex border">
                                                <div class="flex items-center  font-bold text-s  w-100px justify-center border border-gray-200 w-1/4 bg-gray-100">
                                                    <span v-if="formData.warehouse"> {{formData.warehouse.currency}}</span>
                                                </div>
                                                <input type="number" v-model="item.price" disabled min="0" class="w-full focus:outline-none rounded-md bg-white  text-gray-700 focus:text-gray-600 p-2">
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="item-row item-row-n">
                                       <td class="item-row-actions" colspan="4"><button id="invoice-item-add" @click="addFees" title="Add Item" class="btn btn-prime"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plus" class="svg-inline--fa fa-plus fa-w-14 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path></svg></button></td>
                                    </tr>
                                 </tbody>
                            </table>
                            <hr class="divider margin">
                            <div class="invoice-totals-container content-block">
                               <div class="invoice-totals-row invoice-summary-subtotal desktop">
                                    <div class="invoice-summary-label">Products amount</div><div class="invoice-summary-value"><span class="currency"><span class="localized-number"><sup v-if="formData.warehouse">{{formData.warehouse.currency}}</sup> {{formData.details.reduce((a,curr) => a + parseFloat(curr.price), 0).toFixed(2)}}</span></span></div>
                               </div>
                                <div class="invoice-totals-row invoice-summary-tax desktop">
                                    <div class="invoice-summary-label">Other fees</div><div class="invoice-summary-value"><span class="currency"><span class="localized-number"><sup v-if="formData.warehouse">{{formData.warehouse.currency}}</sup> {{formData.fees.reduce((a,curr) => a + parseFloat(curr.price), 0).toFixed(2)}}</span></span></div>
                                </div>
                                <div class="invoice-totals-row invoice-summary-balance invoice-balance bold desktop" data-selector="invoice-balance"><div class="invoice-summary-label">Total</div><div class="invoice-summary-value"><span class="currency"><span class="localized-number"><sup v-if="formData.warehouse">{{formData.warehouse.currency}}</sup> {{(formData.details.reduce((a,curr) => a + parseFloat(curr.price), 0)+formData.fees.reduce((a,curr) => a + parseFloat(curr.price), 0)).toFixed(2)}}</span></span></div></div>
                            </div>
                           </div>
                        </div>

                       

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- ************************************************************************************************-->
            </div>
            <!-- button save -->
            <div class="w-full">
              <div class="pt-3 flex btn-bottom-toolbar justify-end">
                <button
                  class="rounded focus:outline-none mr-4 outline-none text-gray-100 px-3 w-1/6 py-2 bg-blue-500 hover:shadow-inner hover:bg-blue-700 transition-all duration-300"
                  @click="save">
                  Save
                </button>
              </div>
            </div>
            <!--end button save -->
            <!-- ***********************************Pop up Affectation products to Order************************************************ -->
             <vue-modal-2  name="Modal_products" :headerOptions="{title: 'Add Products'}" :noFooter="true" modalSize="lg" @on-close="closePopUp">
              <div class="flex p-5 pt-0  flex-col w-full h-auto mb-12">
                <!-- Header -->
                <div class="flex w-full h-auto justify-center items-center">
                  <div class="flex mb-6 w-full h-auto py-3 justify-center items-center text-2xl font-bold">
                    <span class="w-screen md:w-full h-10 cursor-pointer border border-gray-200 rounded text-sm flex">
                      <input type="search" name="search" v-model="searchText" placeholder="Search"
                        class="flex-grow px-4 rounded-l-full rounded-r-full text-sm focus:outline-none" />
                      <i class="material-icons text-blue-400 m-2 mr-5 text-lg w-4 h-4">search</i>
                    </span>
                  </div>
                </div>
                <div>
                  <div v-if="products.length <= 0" class="py-2">
                    <span class="w-full flex justify-center text-center py-20 border-b border-gray-200 text-base">
                      <p class="font-semibold flex text-blue-500 whitespace-no-wrap">
                        <span class="">No Products found</span>
                      </p>
                    </span>
                  </div>
                  <div v-for="(item, index) in resultSearchUsers" :key="index" :value="item._id"
                    class="flex space-x-12 h-auto py-1 px-5 rounded border border-gray-300 mb-2">
                    <div>
                      <input type="checkbox" class="form-checkbox mt-6 h-5 w-5 text-blue-500 border-blue-500"
                        @change="addProductsToTemp(item, index)" v-model="item.check" />
                    </div>

                    <div><img :alt="item.name" :src="item.picture" class="h-16 w-16 rounded-md mx-auto" /></div>
                    <div class="col-span-2 sm:col-span-4 xl:col-span-4">
                      <h3 class="text-gray-80 mt-1">{{ item.name }}</h3>
                      <p class="text-gray-600 text-xs"> 
                        {{ exceptDes(item.description) }}
                      </p>
                    </div>

                    <div class="mt-4 ">
                      <div
                        class="justify-center text-xs text-center pl-3 pr-2 w-auto bg-blue-100 font-semibold rounded-full text-blue-500">
                        <p>{{ item.price }} <sup v-if="formData.warehouse">{{formData.warehouse.currency}}</sup></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal-footer px-5 border0-t text-right">
                <button @click="closePopUp"
                  class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">
                  Cancel
                </button>
                <button @click="ConfirmOperation"
                  class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-blue-500 py-2 px-8 items-center focus:outline-none md:float-right">
                  Confirm
                </button>
              </div>
            </vue-modal-2>
            <!-- ******************************************************** -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object}
   },
    data() {
      return {
        formData: {
          facturationDate: null,
          provider: {
            name: "",
            phone: "",
          },
          details: [],
          fees: [],
          country: "",
          warehouse:null,
          seller: "",
        },
        paginate: {
          total: 0,
          currentpage: 1,
          lastpage: 1,
          per_page: 0,
        },
        searchText: "",
        products: [],
        warehouses:[],
        show_modal: true,
        productselected: [],
        numberItemRepeated: 0,
        sellers: [],
        status: ['pending', 'accepted','rejected'],
        options:this.$countries
      };
    },
    async mounted() {
      await this.getCurrentSeller();
      //await this.getStatus();
      await this.dataToEdit();
      this.dateMin();
    },
    watch: {
        "formData.details": {
            handler: function (newTodos) {
               for(var i = 0; i < newTodos.length; i++) {
                 console.log('item i-------',newTodos[i])
                 newTodos[i].price=(newTodos[i].priceDH*newTodos[i].quantity)*this.formData.warehouse.info.currency;
                }
                
            },
            deep: true
        },
         "formData.fees": {
            handler: function (newTodos) {
               for(var i = 0; i < newTodos.length; i++) {
                  newTodos[i].price=newTodos[i].priceDH*this.formData.warehouse.info.currency;
                }
                
            },
            deep: true
        }
    },
    methods: {
       RouterBack: function() {
       this.$router.back();
    },
    addFees(){
      this.formData.fees.push({name:"", priceDH:0,price:0})
    },
      dateMin(){ 
          // document.getElementById('dateexp').setAttribute('min', this.$moment(Date.now()).format('yyyy-MM-DD'));
          // if(this.currentUser.type != "Seller")  document.getElementById('dateexpar').setAttribute('min', this.$moment(Date.now()).format('yyyy-MM-DD')); 
      },
      getUsersDebance: _.debounce(async function(name) {
          console.log('name----',name)
          if(this.formData.warehouse){
            await this.$store.dispatch('wharhouse/searchUser',{type: "Seller",warhouse:this.formData.warehouse._id||this.formData.warehouse,search:name}).then((res) => {
              this.sellers = res
            })
          }
       }, 500), 
       async getWarehouses(){
        const filter = {limit:1000};
        const res = await this.$server.search("warehouses",filter);
        if (res.content.results) {
             this.warehouses = res.content.results;
        } else this.warehouses = [];
      }, 
      exceptDes(text){
         if (text && text.length > 60) text = text.substring(0, 60) + "...";
         return text;
      },
      setSelected(contry) {
        if (contry) {
            this.formData.country = contry.name;
        } else {
            this.formData.country = "";
        }
      },
      async setSelectedW(warhouse){
        this.formData.details=[]; this.formData.sellers=[];
         if (warhouse) {
           this.formData.warehouse = warhouse;
           if (this.currentUser.type != "Seller") await this.getSellers(warhouse._id||warhouse);
         }
         else this.formData.warehouse = null;
      },
      setStatusSelected(status) {
        if (status) {
          this.formData.status = status;
        } else {
          this.formData.status = "";
        }
      },
      async getCurrentSeller() {
        this.warehouses =  this.currentUser.warehouses;
         if (this.currentUser.type == "Seller") this.formData.seller = this.currentUser;
      },
      async getSellers(warehouse) {
        const res = await this.$server.search("users", {warehouses:warehouse, type: "Seller",limit:10 });
        if (res.content.results) this.sellers = res.content.results;
        else this.sellers =[]
      },
      async getUser() {
        const res = await this.$server.me("users");
        console.log("res user----",res);
        if (res.content) this.currentUser = res.content;
        else this.currentUser = {};
      },
      async getProducts(filters) {
        if (this.formData.seller) filters.seller = this.formData.seller._id;
        filters.limit=3000;
        console.log('getProducts-----',filters)
        const res = await this.$server.search("products", filters);
        if (res.content.results) {
          this.products = res.content.results;
          this.paginate.total = res.content.total;
          this.paginate.lastpage = res.content.last_page;
          this.paginate.per_page = res.content.per_page;
          this.paginate.currentpage = res.content.current_page;

          // for (let i in this.products) {
          //  // this.products[i].quantity = this.products[i].quantity.inStock;
          // }
        } else this.products = [];
      },
      async save() {
        if (this.formData._id) {
          const data = await this.$server.update("sourcings", this.formData);
          if (data && data._id) {
            alert("Sourcing updated", "success");
            await this.dataToEdit();
          }
        } else {
          console.log('this.formData-----------',this.formData)
          if (this.checkData()) {
            const data = await this.$server.create("sourcings", this.formData);
            if (data && data._id) {
                this.formData = {
                    provider: {name: "",phone: "",},
                    details: [],fees: [],
                };
              if (this.currentUser.type == "Seller") this.formData.seller = this.currentUser;
              alert("Sourcing created !", "success");
            }
          } else alert(`you must fill all the fields !! `, "warning");
        }
      },
      getQuantity() {
        this.formData.quantity = 0;
        for (let i = 0; i < this.formData.details.length; i++) {
          this.formData.quantity += this.formData.details[i].quantity;
        }
      },
      checkData() {
        if (
          this.formData.country &&
          this.formData.facturationDate &&
          this.formData.details.length > 0 &&
          this.formData.provider.name &&
          this.formData.provider.phone &&
          this.formData.seller &&
          this.formData.warehouse
        )
          return true;
        else return false;
      },
      removeProduct(data, index,tab) {
        if(tab==='products'){
           this.$confirm("Are you sure you want to delete this product?").then(
              async (res) => {
                var index = this.formData.details.findIndex(function(o){return o.product._id === data.product._id;})
                if (index !== -1) this.formData.details.splice(index, 1);
                data.product.check = false;
                alert(`Product deleted !`, "success");
              }
            );
        }else{
          this.formData.fees.splice(index, 1);
        }
      
    },

      addProductsToTemp(data, index) {
        if (data.check) {
          const detail = {
            product: data,
            quantity: 1,
            priceDH:0,
            price:0
          };

          let found = 0;
          for (let i = 0; i < this.formData.details.length; i++) {
            if (this.formData.details[i].product._id == data._id) {
              found = found + 1;
              this.numberItemRepeated = this.numberItemRepeated + 1;
            }
          }
          if (found >= 1) {
          } else {
            this.productselected.push(detail);
          }
        } else {
          let pos = this.productselected
            .map(function (e) {
              return e.product._id;
            })
            .indexOf(data._id);
          this.productselected.splice(pos, 1);
        }
      },

      addQuantity(index) {
        this.formData.details[index].quantity++;
      },
      removeQuantity(index) {
        if (this.formData.details[index].quantity <= 1) {
        } else {
          this.formData.details[index].quantity--;
        }
      },
      ViderTable() {
        this.productselected = [];
      },
       ViderProductTable() {
       this.formData.details= [];
       },
     async OpenPopUp() {
         if (this.formData.seller && this.formData.warehouse) {
            // await this.getProducts({'details.warehouse':this.formData.warehouse._id||this.formData.warehouse});
            await this.getProducts({});
             if (this.products.length > 0) {
                   this.$vm2.open("Modal_products");
             }else{
                 if(this.currentUser.type != 'Seller') alert(`There are no products for the selected seller`, "warning");
                 else  alert(`You haven't added any product yet`, "warning");  
             }
         }
      },
      ConfirmOperation() {
        let fount = 0;
        if (this.numberItemRepeated > 0) {
          alert(`There are many products already added!`, "success");
        } else {
          for (let i = 0; i < this.productselected.length; i++) {
            this.formData.details.push(this.productselected[i]);
          }
        }
        this.productselected = [];

        this.numberItemRepeated = 0;
         this.$vm2.close("Modal_products");
      },
      closePopUp() {
         this.$vm2.close("Modal_products");
      },
      async dataToEdit() {
        if (this.$route.params.id) {
          const editData = await this.$server.get("sourcings", {id: this.$route.params.id});
          this.formData = editData.content;
          if(!this.formData.fees) this.formData.fees=[];
          this.formData.facturationDate = this.$moment(this.formData.date).format('yyyy-MM-DDTHH:mm');
        }
      },
    },

    computed: {
      resultSearchUsers() {
        if (this.searchText) {
          return this.products.filter((product) => {
            var regex = new RegExp(this.searchText, "i");

            return regex.test(product.name);
          });
        } else {
          return this.products;
        }
      },
    },

    /************************************* Pagination **************************************************/
  };
</script>

<style>
.vs__dropdown-toggle {
    border: none;
}  
.text-s{
  font-size: 12px;
}
.w-100px{
  width: 90px;
}
.w-130px{
    width: 130px;  
}
.w-160px{
    max-width: 160px;  
}
  .modal-header {
    background: #226faa;
    background: -webkit-gradient(linear,
        left top,
        right top,
        from(#226faa),
        color-stop(37%, #2989d8),
        to(#72c0d3));
    background: linear-gradient(to right, #226faa 0, #2989d8 37%, #72c0d3 100%);
    border-radius: 6px;
    color: #fff;
    padding: 18px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-color: transparent;
    border-bottom: 1px solid #e5e5e5;
  }

  .table.item thead {
    background: #3182ce4f;
    color: #fff;
    border: 0;
  }

  .toggle__dot {
    transition: all 0.3s ease-in-out;
  }

  .seller-select .vs__dropdown-toggle {
    border: none;
  }

  input:checked~.toggle__dot {
    transform: translateX(100%);
    background-color: #68d391;
  }

  /* animation for vue transition tag */
  dialog[open] {
    animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
  }

  dialog::backdrop {
    background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
    backdrop-filter: blur(3px);
  }

  @keyframes appear {
    from {
      opacity: 0;
      transform: translateX(-3rem);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  
  .toggle__dot {
  top: -.25rem;
  left: -.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #63b3ed;
}
</style>
